import { forwardRef } from 'react'
import { useRouter } from 'next/router'
import { m } from 'framer-motion'
import { Section, IconArrow } from '@/components'

export const GoBackButton = forwardRef<HTMLElement>((_, ref) => {
    const router = useRouter()
    return (
        <Section
            ref={ref}
            width="full"
            className="border-t border-v-navy bg-v-white"
        >
            <Section width="default" display="block" className="py-20">
                <m.button
                    key={`${router.asPath}-back`}
                    initial={{ opacity: 0, x: 10 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.5, delay: 0.25 }}
                    onClick={() => router.back()}
                    className="text-v-xs tracking-[0.1em] flex justify-start items-center px-6 py-20 gap-6 group transition-transform duration-400 ease-out"
                >
                    <span className="overflow-hidden inline-flex">
                        <span className="only-sm:loop-slide-x group-hover:loop-slide-x inline-block">
                            <IconArrow
                                direction="left"
                                className="w-[26px] h-auto"
                            />
                        </span>
                    </span>
                    <span className="md:group-hover:opacity-50 transition-opacity">
                        GO BACK
                    </span>
                </m.button>
            </Section>
        </Section>
    )
})
